module.exports = __webpack_public_path__ + "img/SD.827b9dc3.png";